import React from "react";
import { createRoot } from "react-dom/client";
import { mergeStyles } from "@fluentui/react";
import App from "./App";

// basic global styles
mergeStyles({
  ":global(body,html,#root)": {
    margin: 0,
    padding: 0,
    height: "100%",
  },
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);